import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { extend } from '@thd-nucleus/data-sources';
import { Button } from '@one-thd/sui-atomic-components';
import { AddToListDrawer } from './drawers/AddToListDrawer';
import { TRACK } from './constants';

const AddToList = ({
  itemId, quantity, CustomAddToListActionElement, products, skipListId, isSharedList
}) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('add-to-list.ready');
  }, []);

  const closeDrawer = () => {
    setOpen(!open);
  };

  const openDrawer = () => {
    setOpen(true);
    if (window.digitalData?.page?.pageInfo?.pageType === 'pip') {
      window.LIFE_CYCLE_EVENT_BUS.trigger(TRACK.BUTTON_CLICK, {});
    }
    LIFE_CYCLE_EVENT_BUS.trigger(TRACK.OPEN_DRAWER, {});
  };

  return (
    <span data-component="AddToList">
      {CustomAddToListActionElement
        ? <CustomAddToListActionElement onClick={openDrawer} />
        : (
          <Button
            variant="secondary"
            fullWidth
            onClick={openDrawer}
          >
            Add to List
          </Button>
        )}
      {
        open && (
          <AddToListDrawer
            itemId={itemId}
            quantity={quantity}
            products={products}
            open={open}
            onClose={closeDrawer}
            skipListId={skipListId}
            isSharedList={isSharedList}
          />
        )
      }
    </span>
  );
};

AddToList.propTypes = {
  itemId: PropTypes.string,
  skipListId: PropTypes.string,
  isSharedList: PropTypes.bool,
  quantity: PropTypes.number,
  CustomAddToListActionElement: PropTypes.func,
  products: PropTypes.arrayOf(PropTypes.shape({
    itemId: PropTypes.string,
    quantity: PropTypes.number,
    price: PropTypes.number
  }))
};

AddToList.defaultProps = {
  itemId: null,
  skipListId: null,
  quantity: 1,
  CustomAddToListActionElement: null,
  products: [],
  isSharedList: false
};

AddToList.displayName = 'AddToList';

AddToList.dataModel = extend(
  AddToListDrawer
);

export { AddToList };
